<template>
  <v-row justify="center" class="reply">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
      class="reply-modal"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          點我回報實驗數據
        </v-btn>
      </template>
      <v-card >
        <v-card-title>
          <span class="headline">數據回報</span>
        </v-card-title>
        
        <v-card-text>
          <v-container>
            <v-alert :type="alert.type" :value="alert.show">
      {{alert.message}}
    </v-alert>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  label="投擲次數*"
                  type="number"
                  v-model="formdata.throw"
                  :error="ferror.throw"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="相交次數*"
                  type="number"
                  v-model="formdata.cross"
                  :error="ferror.cross"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="回報序號*"
                  v-model="formdata.uid"
                  :error="ferror.uid"
                  required
                ></v-text-field>
              </v-col>
              
            <v-col cols="12">
              <v-text-field
            v-model="estimated_pi"
            label='圓周率預估值'
            :error="input_error"
            outlined
            readonly
          ></v-text-field>
          </v-col>
            </v-row>
          </v-container>
          <small>*必填</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="btnclose"
          >
            關閉
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="btn_disable"
          >
            {{submit_label}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import {analytics} from '../plugins/firebase'; 


  export default {
    data: () => ({
      dialog: false,
      submit_label: '送出',
      btn_disable:false,
      formdata:{ throw: '', cross: '', uid: '' },
      ferror:{ throw: false, cross: false, uid: false },
      alert:{show:false,type:'success',message:''},
      input_error:false,
      estimated_pi:'',
      factor:10/10.4
    }),
    methods: {
      submit: function () {
        // `this` inside methods points to the Vue instance
        if(this.input_error){
            if(!confirm("您的實驗誤差似乎有點大，確定送出？")){
              return false;
            }
        }
        var formHasErrors = false
        Object.keys(this.formdata).forEach(f=>{
          if(this.formdata[f]){
            this.ferror[f]=false
          }else{
            this.ferror[f]=true
            formHasErrors = true
          }
        })
        if(formHasErrors){
          this.alert = {show:true,type:'error',message:'請檢查數據'}
          return false
        }

        this.submit_label = '送出中......';
        this.btn_disable = true;
        axios.post('https://xd.emath.tw/piday/form', qs.stringify(
            this.formdata
        )).then(() => {
          this.alert = {show:true,type:'success',message:'送出成功'}
          this.submit_label = '送出';
          this.btn_disable = false;
          this.formdata = { throw: '', cross: '', uid: '' };
          this.estimated_pi = '';
          setTimeout(()=>{ this.dialog = false; }, 400);
          analytics.logEvent('reply_submitted_success');
        }).catch(() => { 
          this.alert = {show:true,type:'error',message:'送出失敗'}
          this.submit_label = '送出';
          this.btn_disable = false;
          analytics.logEvent('reply_submitted_failed');

        })
        
      },
      btnclose : function(){
        this.dialog = false;
        this.btn_disable = false;
        this.alert={show:false,type:'success',message:''};
      }
    },
    watch: {
      'formdata.throw': function(val){
            this.estimated_pi = Math.round(2 * val/this.formdata.cross*this.factor*1000)/1000
            var errbdd = 11.64*Math.pow(val,-0.634);
            if(Math.abs(this.estimated_pi-3.14)>errbdd || !isFinite(this.estimated_pi) ){
                this.input_error = true;
            }else{
                this.input_error = false;
            }
            if(val){
              this.ferror.throw = false;
            }
      },
      'formdata.cross': function(val){
            this.estimated_pi = Math.round(2 * this.formdata.throw/val*this.factor*1000)/1000
            var errbdd = 11.64*Math.pow(this.formdata.throw,-0.634);
            if(Math.abs(this.estimated_pi-3.14)>errbdd || !isFinite(this.estimated_pi) ){
                this.input_error = true;
            }else{
                this.input_error = false;
            }
            if(val){
              this.ferror.cross = false;
            }
      },
      'formdata.uid': function(val){
        if(val){
              this.ferror.uid = false;
            }
      }
    }
  }
</script>

<style  scoped>
.reply{
    padding-top: 30px;
    padding-bottom: 30px;
}

.reply-modal{
    z-index: 500;
}
</style>